<div class="container-upload-picture">
    <div class="row" *ngIf="!multiple && !gridArray">
        <div class="col-12">

            <input #inputFile type="file" (change)="changeListenerDoc($event)" [hidden]="true"
                accept="image/png, image/jpeg">
            {{ label | translate }}
        </div>
        <div class="col-12">

            <div class="img-view" *ngIf="media" (click)="openMedia(media)">
                <div class="box-img">
                    <img [src]="media.base64" alt="" *ngIf="!media.id" />
                    <img [src]="'/api/' + media.urlWebp" alt="" *ngIf="media.id" />
                </div>
                <div class="sup-btn" (click)="removeFile($event)">
                    <fa-icon [icon]="['fas', 'times']"></fa-icon>
                </div>
            </div>

            <div class="btn btn-primary btn-sm" (click)="addFile()" *ngIf="!media">
                <fa-icon [icon]="['fas', 'camera']"></fa-icon> &nbsp;
                {{ 'Add.file' | translate }}
            </div>
        </div>
    </div>

    <div class="row" *ngIf="multiple && !gridArray">
        <div class="col-12">

            <input #inputFileMult type="file" (change)="changeListenerDocMult($event)" [hidden]="true"
                accept="image/png, image/jpeg" multiple>
            {{ label | translate }}
        </div>
        <div class="col-12">
            <div class="list-img" *ngIf="medias && medias.length">
                <div class="img-view" *ngFor="let media of medias;let index = index" (click)="openMedia(media)">
                    <div class="box-img">
                        <img [src]="media.base64" alt="" *ngIf="!media.id" />
                        <img [src]="'/api/' + media.urlWebp" alt="" *ngIf="media.id" />
                    </div>
                    <div class="sup-btn" (click)="removeFileMult($event,index)">
                        <fa-icon [icon]="['fas', 'times']"></fa-icon>
                    </div>
                </div>
            </div>

            <div class="btn btn-primary btn-sm" (click)="addFileMult()"
                *ngIf="!medias || !maxLength || medias.length < maxLength">
                <fa-icon [icon]="['fas', 'camera']"></fa-icon> &nbsp;
                {{ 'Add.file' | translate }}
            </div>
        </div>
    </div>

    <div class="row" *ngIf="!multiple && gridArray">
        <div class="col-12">

            <input #inputFileGrid type="file" (change)="changeListenerDocGrid($event)" [hidden]="true"
                accept="image/png, image/jpeg">
            {{ label | translate }}
        </div>
        <div class="col-12">

            <div class="grid-medias">
                <div class="gdmedia" *ngFor="let gdMedia of gridMedias;let index = index">
                    <div class="img-box" *ngIf="gdMedia.src" (click)="openMediaGrid(gdMedia)">

                        <img [src]="gdMedia.src" alt="" *ngIf="!gdMedia.id" />
                        <img [src]="'/api/' + gdMedia.src" alt="" *ngIf="gdMedia.id" />

                        <div class="label">
                            {{ gdMedia.gridLabel }}
                        </div>

                        <div class="sup-btn" (click)="removeFileGrid($event,gdMedia)">
                            <fa-icon [icon]="['fas', 'times']"></fa-icon>
                        </div>

                    </div>
                    <div class="add-box" *ngIf="!gdMedia.src" (click)="addFileGrid(gdMedia)">
                        <div class="icon">
                            <fa-icon [icon]="['fas', 'camera']"></fa-icon>
                        </div>
                        <div class="label">
                            {{ gdMedia.gridLabel }}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="row" *ngIf="multiple && gridArray">
        <div class="col-12">

            <input #inputFileMultGrid type="file" (change)="changeListenerDocMultGrid($event)" [hidden]="true"
                accept="image/png, image/jpeg" multiple>
            {{ label | translate }}
        </div>
        <div class="col-12">
            Non géré
        </div>
    </div>
</div>